// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"02bbd03b","455":"99e74087","977":"c086e37c"}[chunkId] + ".chunk.js";
};